import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { listSearchSchema } from '@/lib/list-search-schema';
import Parts from '@/pages/Parts';

export const partsSearchSchema = listSearchSchema.extend({
  status: z.string().optional(),
});

export type PartsSearch = z.infer<typeof partsSearchSchema>;

export const Route = createFileRoute('/_authenticated/parts')({
  validateSearch: partsSearchSchema,
  component: Parts,
});
